import { useLocation, Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import axios from 'axios';

export function AxiosErrorHandleProvider({ children }) {
  const navigate = useNavigate(); // Hooksが使用できる！！

  useEffect(() => {
    // axiosの共通エラーハンドリング記述
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        switch (error.response?.status) {
          case 401:
            localStorage.removeItem('temitope');
            navigate('/login'); // navigateを使用してリダイレクト
            return Promise.reject(error.response?.data);
        }
        return Promise.reject(error);
      },
    );
  }, []);

  return <>{children}</>;
}
